import { Point } from 'geojson'
import { styled } from 'styled-components'
import ItemLocationPin from '../administration/plots/ItemLocationPin'
import CustomMarker from '../map/CustomMarker'
import StandaloneGoogleMap from '../map/StandaloneGoogleMap'

const MapWrapper = styled(Box)`
  position: relative;
  width: 100%;
  padding-bottom: 100%;
`

const MapContainer = styled(Box)`
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: ${(p) => p.theme.radiuses.md}px;
`

const NetworkHeadquarterMap = ({ hqLocation }: {hqLocation: Point}) => {
  return (
    <MapWrapper>
      <MapContainer>
      <StandaloneGoogleMap
        hideControls
        defaultCenter={{ lat: hqLocation.coordinates[1], lng: hqLocation.coordinates[0] }}
        defaultZoom={14}
      >
        <CustomMarker lat={hqLocation.coordinates[1]} lng={hqLocation.coordinates[0]} size={36}>
          <ItemLocationPin item='headquarter' />
        </CustomMarker>
      </StandaloneGoogleMap>
      </MapContainer>
    </MapWrapper>
  )
}

export default NetworkHeadquarterMap
